module.exports = __webpack_public_path__ + "static/img/1096.3d0602a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/1096.jpg
// module id = 278
// module chunks = 0